import React, { useEffect, useState } from 'react';
import './index.less';
import FloorSearchbar from './components/floor-searchbar/index';
import FloorAnalysisList from './components/floor-analysis-list/index';
import FloorKeyIndicators from './components/floor-key-indicators';
import apis from '../../apis';
import { message, Empty, Spin } from '@drip/drip-design';
import CommodityData from '@/pages/data-panel/activity-data/commodity-data';
import CommonNoAccess from '@/pages/mvp-panel/participant-data/components/no-access';

function Search() {
  const [conditions, setConditions] = useState({ dataType: 'OFFLINE' });
  const [dataScopeDept, setDataScopeDept] = useState([]);
  const [empty, setEmpty] = useState(false);
  /**
   * 更新数据
   * @param data
   */
  const onChange = (data: any) => {
    setConditions((value: any) => Object.assign({}, value, data));
    console.log(Object.assign({}, conditions, data), '更新搜索数据');
  };

  /**
   *  删除数组对象深层嵌套指定值
   * @param arr
   * @param key
   * @returns
   */
  const deleteDeepValue = (arr: any, key: string) => {
    return arr.map((item: any) => {
      if (item[key]) {
        delete item[key];
      }
      if (item.children) {
        item.children = deleteDeepValue(item.children, key);
      }
      return item;
    });
  };

  /**
   * 获取运营部门数据
   */
  useEffect(() => {
    apis
      .queryGeneralDataScopeByErp({
        resId: 4338, // online 3643, dev  4338
      })
      .then((res) => {
        const { ret, data } = res;
        if (ret != 0 || !data?.dataScope?.dept?.length) throw '暂无数据';
        setEmpty(false);
        const dept = deleteDeepValue(data.dataScope.dept, 'key');
        setDataScopeDept(dept);
      })
      .catch((ex) => {
        setEmpty(true);
        message.error(ex);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="participant-data-search">
      {!dataScopeDept?.length ? (
        empty ? (
          <CommonNoAccess/>
          // <Empty style={{ padding: '100px 0' }} description={'您暂无部门权限，申请开通后即可访问'} />
        ) : (
          <div className="search-loading">
            <Spin />
            <p>数据加载中...</p>
          </div>
        )
      ) : (
        <>
          {/* 搜索条 */}
          <FloorSearchbar onChange={onChange} dataScopeDept={dataScopeDept} />
          {/* 关键指标+商品漏洞+趋势图 */}
          <FloorKeyIndicators conditions={conditions} />
          {/* 分析列表 */}
          <FloorAnalysisList conditions={conditions}></FloorAnalysisList>
        </>
      )}
    </div>
  );
}
export default Search;
